// Libraries
var React = require('react');

// Components
var InlineShareModule = require('InlineShare/InlineShareModule');

// Styles
require('./VideoModule.scss');

// Components
var VideoPlaceholder = require('./VideoPlaceholder');
var VideoModal = require('./VideoModal');
var VideoEmbed = require('./VideoEmbed');

class VideoModule extends React.Component {

	constructor(props) {

		super(props);

		this.state = {
			videoPlaying: !!this.props.data.isAutoplay,
			isModalOpen: !!this.props.data.isAutoplay
		};
	}
	

	playVideoInline = (event) => {
		this.setState({...this.state, videoPlaying: true});

		global.DY.API('event', {
			name: 'Video Watch',
			properties: {
			dyType: 'video-watch-v1',
			itemId: this.props.data.id, // Mandatory string ID - must match an 'id' present in the Content Feed
			//categories: ['Sports', 'Baseball'], // Optional, independent of whether an ID was given
			//autoplay: true, // Default is false,
			// Specifies whether the user has explicitly requested the video to play
			//progress: 'VIDEO_PROGRESS', // Default is: VIDEO STARTED
			//progressPercent: 65 // Meaning: 65% of video length has passed.
			// Only relevant if progress mode is 'VIDEO_PROGRESS'
			}
			});
	};

	playVideoModal = (event) => {	
		event.stopPropagation();
		event.preventDefault();
		this.setState({...this.state, videoPlaying: true, isModalOpen: true});

		global.DY.API('event', {
			name: 'Video Watch',
			properties: {
			dyType: 'video-watch-v1',
			itemId: this.props.data.id, // Mandatory string ID - must match an 'id' present in the Content Feed
			//categories: ['Sports', 'Baseball'], // Optional, independent of whether an ID was given
			//autoplay: true, // Default is false,
			// Specifies whether the user has explicitly requested the video to play
			//progress: 'VIDEO_PROGRESS', // Default is: VIDEO STARTED
			//progressPercent: 65 // Meaning: 65% of video length has passed.
			// Only relevant if progress mode is 'VIDEO_PROGRESS'
			}
			});
	};

	onCloseModal = () => {
		this.setState({...this.state, videoPlaying: true, isModalOpen: false});
	};

	mouseEnter = () => {
		this.videoRef.nextElementSibling.querySelector('.ArticleLink__headline').classList.add('underline');
	};

	mouseLeave = () => {
		this.videoRef.nextElementSibling.querySelector('.ArticleLink__headline').classList.remove('underline');
	};

	render() {
		const videoPlaceholder = <VideoPlaceholder
			thumbnail={this.props.data.thumbnail}
			playVideo={this.props.data.displayType === "MODAL" ? this.playVideoModal : this.playVideoInline}
			type={this.props.data.type}
			articleLink={this.props.articleLink}
			externalLink={this.props.data.externalLink}
			caption={this.props.data.caption}
			membershipTier={this.props.data.membershipTier}
		/>
		return (
			<div className="Video" ref={video => this.videoRef = video}>
				{
					this.props.data.displayType === "MODAL" ? (
						<div className="Video__wrapper">
							{this.props.articleLink && this.props.showPageLink && !this.props.data.externalLink ? (
								<a className="Video__anchor-wrapper" href={this.props.articleLink} onMouseEnter={this.mouseEnter} onMouseLeave={this.mouseLeave} ref={link => this.articleLinkRef = link}>
									{videoPlaceholder}
								</a>
							) : videoPlaceholder}
							<VideoModal isOpen={this.state.isModalOpen} onCancel={this.onCloseModal}>
								<VideoEmbed type="STREAM" data={this.props.data} publishedDate={this.props.publishedDate} autoplay />
							</VideoModal>
						</div>
					) : (

						!this.state.videoPlaying ? videoPlaceholder : (
							<VideoEmbed type="STREAM" data={this.props.data} publishedDate={this.props.publishedDate} />
						)
					)
				}
				{this.props.data.caption && !this.props.data.hideCaption &&
						<div className="Video__caption">{this.props.data.caption}</div>
				}
				{this.props.data.sharing &&
						<div className="Video__share">
							<InlineShareModule data={this.props.data.sharing} />
						</div>
				}
			</div>
		)
	}
}

module.exports = VideoModule;



// WEBPACK FOOTER //
// ./src/components/Video/VideoModule.js